var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7671 0.680054L13.3533 4.96676L17.6401 6.55299L13.3533 8.13921L11.7671 12.4259L10.1809 8.13921L5.89414 6.55299L10.1809 4.96676L11.7671 0.680054Z",
    fill: "#1D77B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4259 10.4683L5.81155 12.5085L7.85179 13.8942L5.81155 15.2798L4.4259 17.32L3.04024 15.2798L1 13.8942L3.04024 12.5085L4.4259 10.4683Z",
    fill: "#1D77B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7671 0.680054L13.3533 4.96676L17.6401 6.55299L13.3533 8.13921L11.7671 12.4259L10.1809 8.13921L5.89414 6.55299L10.1809 4.96676L11.7671 0.680054Z",
    stroke: "#1D77B7",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4259 10.4683L5.81155 12.5085L7.85179 13.8942L5.81155 15.2798L4.4259 17.32L3.04024 15.2798L1 13.8942L3.04024 12.5085L4.4259 10.4683Z",
    stroke: "#1D77B7",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.1e9d92e0667a77dad0d47a108bf7ba90.svg";
export { ForwardRef as ReactComponent };